import React from 'react';
import { isObject } from 'lodash';

export function mergeRefs<T>(...refs: Array<React.Ref<T> | undefined>): React.RefCallback<T> {
    return (node) =>
        refs.forEach((ref) => {
            if (typeof ref === 'function') ref(node);
            else if (isObject(ref)) (ref as React.MutableRefObject<T | null>).current = node; // eslint-disable-line no-param-reassign
        });
}
